import { useParams } from "react-router-dom";
import CompaniesPage from "./company/CompaniesPage";
import SavingsProfilesPage from "./savingsprofile/SavingsProfilesPage";
import Sidebar from "../sidebar/Sidebar";
import React, { useEffect } from "react";
import NotFoundPage from "./NotFoundPage";
import { getPensionProductType } from "../../data/PensionProductType";
import { getTableType } from "../../data/TableType";
import { useMatomo } from "frno-react";

export default function MainContent() {
  const { productType, tableType } = useParams();

  const { trackPageView } = useMatomo();

  useEffect(() => {
    trackPageView();
  }, [productType, tableType]);

  function findPage(tableType: string): React.ReactNode {
    const pensionProductType = getPensionProductType(productType!);
    switch (tableType) {
      case "selskaper":
        return <CompaniesPage pensionProductType={pensionProductType} />;
      case "spareprofiler":
        return <SavingsProfilesPage pensionProductType={pensionProductType} />;
    }
  }

  if (
    productType &&
    getPensionProductType(productType) &&
    tableType &&
    getTableType(tableType)
  ) {
    const page = findPage(tableType);
    return (
      <>
        <Sidebar />
        {page}
      </>
    );
  } else {
    return <NotFoundPage />;
  }
}
